export const GET_REFLECTIVE_ACCOUNT =
  'src/modules/revalidation/reflectiveAccount/GET_REFLECTIVE_ACCOUNT';
export const CANCEL_ALL_API_REQUESTS =
  'src/modules/revalidation/reflectiveAccount/CANCEL_ALL_API_REQUESTS';
// export const APPLY_PAGINATION =
//   'src/modules/jobs/APPLY_PAGINATION';
export const POST_REFLECTIVE_ACCOUNT =
  'src/modules/revalidation/reflectiveAccount/POST_REFLECTIVE_ACCOUNT';
